import { render, staticRenderFns } from "./iconOrders.vue?vue&type=template&id=3cd3f0d2&scoped=true"
import script from "./iconOrders.vue?vue&type=script&lang=js"
export * from "./iconOrders.vue?vue&type=script&lang=js"
import style0 from "./iconOrders.vue?vue&type=style&index=0&id=3cd3f0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd3f0d2",
  null
  
)

export default component.exports